import { mergeProps as _mergeProps, createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6f4c1ab6"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["disabled", "value"]
const _hoisted_2 = { class: "oxd-buzz-post-slot" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oxd_text = _resolveComponent("oxd-text")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.classes)
    }, [
      _createElementVNode("textarea", _mergeProps({
        rows: "1",
        ref: "textArea",
        class: "oxd-buzz-post-input",
        disabled: _ctx.disabled,
        value: _ctx.modelValue,
        onBlur: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onBlur && _ctx.onBlur(...args))),
        onFocus: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onFocus && _ctx.onFocus(...args))),
        onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onInput && _ctx.onInput(...args)))
      }, _ctx.$attrs), null, 16, _hoisted_1),
      _createElementVNode("div", _hoisted_2, [
        _renderSlot(_ctx.$slots, "default", {}, undefined, true)
      ])
    ], 2),
    (_ctx.hasError)
      ? (_openBlock(), _createBlock(_component_oxd_text, {
          key: 0,
          tag: "span",
          class: "oxd-input-field-error-message"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.message), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}